export default {
  data: function data() {
    return {};
  },
  methods: {
    sizeChange: function sizeChange(e) {
      this.paramsData.page_size = e;
      this.getList && this.getList(1);
    }
  }
};